import { z } from 'zod'
import {
  isValidUnifiedSocialCreditCode,
  normalizeUnifiedSocialCreditCode,
  UNIFIED_SOCIAL_CREDIT_CODE_LENGTH,
} from '@/utils/unifiedSocialCreditCode'

/** GB 32100-2015：18 位统一社会信用代码 */
export const SOCIAL_CREDIT_CODE_LIMITS = {
  length: UNIFIED_SOCIAL_CREDIT_CODE_LENGTH,
} as const

function normalizeUsccInput(value: unknown): string {
  return normalizeUnifiedSocialCreditCode(value)
}

/** 统一社会信用代码（必填） */
export const socialCreditCodeSchema = z
  .string()
  .transform(normalizeUsccInput)
  .pipe(
    z.string().superRefine((v, ctx) => {
      if (!v) {
        ctx.addIssue({ code: 'custom', message: '请输入统一社会信用代码' })
        return
      }
      if (v.length !== SOCIAL_CREDIT_CODE_LIMITS.length) {
        ctx.addIssue({
          code: 'custom',
          message: `统一社会信用代码须为 ${SOCIAL_CREDIT_CODE_LIMITS.length} 位，当前 ${v.length} 位`,
        })
        return
      }
      if (!isValidUnifiedSocialCreditCode(v)) {
        ctx.addIssue({ code: 'custom', message: '统一社会信用代码格式不正确' })
      }
    }),
  )

/** 选填：空值通过；有值则须为合法 18 位 */
export const optionalSocialCreditCodeSchema = z
  .string()
  .transform(normalizeUsccInput)
  .pipe(
    z.string().refine((v) => {
      if (!v) return true
      return v.length === SOCIAL_CREDIT_CODE_LIMITS.length && isValidUnifiedSocialCreditCode(v)
    }, `统一社会信用代码须为 ${SOCIAL_CREDIT_CODE_LIMITS.length} 位且格式正确`),
  )
